import { useSelector } from "react-redux";
import { getMarketingTrackingVariable } from "@flights/web-api-utils-universal";
import useGlobalContext from "./useGlobalContext.js";
import useTrackFlightsWebUseOfferPos from "./useTrackFlightsWebUseOfferPosExp.js";
import { getFlightPointOfSale, getHasFlight } from "../store/flightDetails/selectors.js";
const useIsSaleCountry = (country) => {
    const { ipCountry } = useGlobalContext();
    const flightPointOfSale = useSelector(getFlightPointOfSale);
    const hasFlight = useSelector(getHasFlight);
    const flightsWebUseOfferPosExp = useTrackFlightsWebUseOfferPos();
    const metaSalesCountry = flightsWebUseOfferPosExp.isVariant && getMarketingTrackingVariable("salesCountry");
    return hasFlight
        ? flightPointOfSale === country
        : metaSalesCountry
            ? metaSalesCountry.toLowerCase() === country
            : ipCountry == country;
};
export default useIsSaleCountry;
